// Shared score → rating/traffic-light mapping, used by both the in-pane
// BigScoreCard and the headless notification-bar handlers in commands.ts.
// Keeping it in one place means the label, gauge colour, and bar colour/emoji
// can never drift apart.
//
// Rating terminology is the client-approved 5-band table (BUG-005). The UI
// derives everything from the numeric score; the backend's 4-key verdict enum
// stays untouched (it's persisted in history documents).

export type Band = "red" | "gold" | "green";

export interface ScoreRating {
  label: string;
  band: Band;
}

// Client-approved score → rating table (BUG-005, 6/10 bug list).
export function ratingForScore(score: number): ScoreRating {
  if (score >= 91) return { label: "Exceptional ASLAN Alignment", band: "green" };
  if (score >= 76) return { label: "Advanced ASLAN Alignment", band: "green" };
  if (score >= 61) return { label: "Strong ASLAN Alignment", band: "gold" };
  if (score >= 51) return { label: "Good Foundation, Opportunities for Enhancement", band: "gold" };
  return { label: "Foundational Revisions Recommended", band: "red" };
}

// Main accent colour per band (gauge number, range-bar fill, glow).
export const BAND_COLOR: Record<Band, string> = {
  red: "#e53935",
  gold: "#e6a817",
  green: "#16a34a",
};

// The gauge asset is painted gold; we recolour it per band with a hue-rotate
// filter (gold stays untouched).
export const BAND_FILTER: Record<Band, string> = {
  red: "hue-rotate(-38deg) saturate(1.25)",
  gold: "none",
  green: "hue-rotate(92deg) saturate(0.95)",
};

// Coloured emoji used in the notification bar — on Outlook web / new Outlook /
// Mac the bar's custom icon is replaced with a generic info icon, so the colour
// has to live in the text. Emoji render on every platform.
export const BAND_EMOJI: Record<Band, string> = {
  red: "🔴",
  gold: "🟡",
  green: "🟢",
};

